// extracted by mini-css-extract-plugin
module.exports = {"main-component":"hollowCircle_main-component__2Ab7D"};